<template>
    <poverty-visualization :charts="charts" :title="title" :initial-chart-id="initialChartId" :chart-type="chartType" :y-domain="yDomain"></poverty-visualization>
</template>
<script>
    import PovertyVisualization from './PovertyVisualization';
    export default{
        data: function(){
            return {
                title: 'Contribución relativa de dimensiones a la pobreza multidimensional',
                initialChartId: 'zona',
                chartType: 'StackedBarChart',
                yDomain: [0, 100],
                charts: [
                    {
                        id: 'zona',
                        title: 'Zonas Urbanas y Rurales',
                        file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vS_VK2TdM2KySAUctg-u8mlxgA7U_LRm1nNqsgL1qQr9F-5yOd9KnDWbro_qfjvtJgowhc1eAkUyfB7/pub?gid=0&single=true&output=csv',
                        countryFile: '',
                        dimensions: ['zona','dimension']
                    },
                    {
                        id: 'dimension',
                        title: 'Regiones',
                        file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vT-gsy-Mjo0vNCG3d5jnd_0stppL1sXhSyq1e2OSwGY6tgn4wka-k_hbtdh3DwlNktKzZC1_Cuyf97g/pub?gid=0&single=true&output=csv',
                        countryFile: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vQmlX4wpwnIqBjmCeVZsYvRHjSskHfuDhF1ZBWy1Z2_XpifwVy0lY8WJy2m7RbrPj5NuII-b9na83mh/pub?gid=0&single=true&output=csv',
                        dimensions: ['nom_reg','dimension']
                    }
                ]
            }
        },
        components: {
            PovertyVisualization
        }

    }
</script>


// WEBPACK FOOTER //
// src/js/Components/Visualizations/PovertyMultiDimensionVisualization.vue